"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerListSdkEvents = void 0;
/**
 * События PlayerListSdk.
 */
var PlayerListSdkEvents;
(function (PlayerListSdkEvents) {
    /**
     * Для элемента отрисовывается фон (нет гарантий, что картинка уже загружена).
     */
    PlayerListSdkEvents["Drawing"] = "Drawing";
    /**
     * Изменился активный элемент.
     */
    PlayerListSdkEvents["Activating"] = "Activating";
    /**
     * Для элемента отрисован фон (картинка загружена)
     */
    PlayerListSdkEvents["ImageLoaded"] = "ImageLoaded";
    /**
     * Предзагружено видео
     */
    PlayerListSdkEvents["VideoPreloaded"] = "VideoPreloaded";
    /**
     * Инициализация PlayerListSdk
     */
    PlayerListSdkEvents["Init"] = "Init";
})(PlayerListSdkEvents || (exports.PlayerListSdkEvents = PlayerListSdkEvents = {}));
